var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',{style:('height:'+_vm.bodyHeight+'px;')},[_c('div',{staticStyle:{"width":"98%"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("十五天账目概览")])]),_c('ve-line',{attrs:{"data":_vm.accountsData,"settings":{area: true,
                        labelMap: {
                            Date:'日期',
                            ActualCommission: '佣金收入',
                            SwipeCommission: '佣金支出',
                            SwipePromote: '刷手推广费',
                            SwipePraise: '刷手好评费',
                            MerchantPromote: '商家推广费',
                            MerchantPraise: '好评收入',
                            GrossProfit: '毛利',
                        },
                        yAxisType: ['0.[00]a'],
                    }}})],1)],1)])],1),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("十五天注册刷手趋势")])]),_c('ve-line',{attrs:{"data":_vm.swipeData,"settings":{area: false,
                        labelMap: {
                            Date:'日期',
                            RegisterNum: '注册会员',
                            EffectiveNum: '有效会员',
                            ConversionRate: '转换率'
                        },
                        axisSite: {
                            right: ['ConversionRate'],
                        },
                        yAxisType: ['0.[00]a', '0.[00]%'],
                    }}})],1)],1)])],1),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("十五天活跃刷手趋势")])]),_c('ve-line',{attrs:{"data":_vm.swipeActiveData,"height":"320px","settings":{
                        labelMap: {
                            StartNum: '活跃会员',
                            OkNum: '完单会员',
                            ConversionRate: '成功率'
                        },
                        axisSite: {
                            right: ['ConversionRate']
                        },
                        yAxisType: ['0.[00]a', '0.[00]%'],
                    }}})],1)],1)])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }